import React, { Suspense, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { QueryRouter, Route, Routes } from "src/lib/router";
import { usePluginConfig } from "./contexts/pluginContext";
import { useTracking } from "./contexts/trackingContext";
import PluginFrame from "./utils/PluginFrame";

const EventPage = React.lazy(() => import("src/pages/event"));
const CalendarPage = React.lazy(() => import("src/pages/index"));
const WidgetPage = React.lazy(() => import("src/pages/widget"));
const EventPreviewPage = React.lazy(() => import("src/pages/event_preview"));
const EventWidgetPage = React.lazy(() => import("src/pages/event_widget"));
const NotFoundPage = React.lazy(() => import("src/pages/404"));

const App = () => {
	const pluginConfig = usePluginConfig();
	const frameConfig = pluginConfig.frameConfig;
	const pluginFrame = new PluginFrame(frameConfig);
	const onRouteChangeStart = () => {
		pluginFrame.rootNode.scrollIntoView({
			behavior: "instant",
			block: "start",
		});
	};

	useEffect(() => {
		if (frameConfig.type === "calendar") {
			window.history.scrollRestoration = "manual";
		}
	}, [frameConfig.type]);

	const { tracker } = useTracking();
	const { ref } = useInView({
		triggerOnce: true,
		onChange: (inView) => {
			if (inView) {
				tracker.trackPageView();
			}
		},
	});
	const pluginTypeSelector = () => {
		if (frameConfig.type === "calendar") {
			return (
				<QueryRouter
					pathParam="_evDiscoveryPath"
					onRouteChangeStart={onRouteChangeStart}
				>
					<Suspense fallback="Loading...">
						<Routes>
							<Route path="/" component={<CalendarPage />} />
							<Route path="/:category" component={<CalendarPage />} />
							<Route path="/event/:eventId" component={<EventPage />} />
							<Route path="/:splat*" component={<NotFoundPage />} />
						</Routes>
					</Suspense>
				</QueryRouter>
			);
		}

		if (frameConfig.type === "widget") {
			return <WidgetPage />;
		}

		if (frameConfig.type === "preview_event") {
			return <EventPreviewPage />;
		}

		if (frameConfig.type === "single_event_widget") {
			return <EventWidgetPage />;
		}
	};

	return (
		<div
			id="frame-container"
			className="@container bg-white"
			style={{ width: "100%" }}
			ref={ref}
		>
			{pluginTypeSelector()}
		</div>
	);
};

export default App;
